import {
    useEffect,
    useMemo,
    useState,
} from 'react';

import {
    ADAPTIVE_BREAKPOINT,
    ADAPTIVE_MODE,
} from '../constants';
import {
    getLsManualAdaptiveMode,
} from '../helpers/getLsManualAdaptiveMode';
import {
    getZoom,
} from '../helpers/getZoom';
import {
    setLsManualAdaptiveMode,
} from '../helpers/setLsManualAdaptiveMode';

import {
    useWindowWidth,
} from './useWindowWidth';

export function useManualAdaptiveMode() {
    const [manualAdaptiveMode, setManualAdaptiveMode] = useState<ADAPTIVE_MODE | null>(getLsManualAdaptiveMode);

    const {windowWidth} = useWindowWidth();

    const availableManualAdaptiveMode = useMemo<ADAPTIVE_MODE | null>(() => {
        const res = windowWidth < ADAPTIVE_BREAKPOINT.W1024 ? ADAPTIVE_MODE.DESKTOP : ADAPTIVE_MODE.MOBILE;

        return manualAdaptiveMode ? null : res;
    }, [manualAdaptiveMode, windowWidth]);

    const switchManualAdaptiveMode = () => {
        setManualAdaptiveMode(availableManualAdaptiveMode);

        if (manualAdaptiveMode !== availableManualAdaptiveMode) {
            setLsManualAdaptiveMode(availableManualAdaptiveMode);
            window.location.reload();
        }
    };

    useEffect(() => {
        const manualAdaptiveMode = getLsManualAdaptiveMode();

        manualAdaptiveMode ?
            document.documentElement.setAttribute('adaptive', manualAdaptiveMode) :
            document.documentElement.removeAttribute('adaptive');
        // @ts-ignore
        document.documentElement.style.zoom = getZoom(manualAdaptiveMode);
    }, []);

    return {
        availableManualAdaptiveMode,
        switchManualAdaptiveMode,
    };
}
